function t(t) {
  var e = t.getBoundingClientRect(),
      i = e.left,
      n = e.right,
      o = e.top,
      s = e.bottom,
      r = window.pageYOffset;
  return {
    height: s - o,
    width: n - i,
    top: {
      y: r + o,
      x: i + (n - i) / 2
    },
    bottom: {
      y: r + s,
      x: i + (n - i) / 2
    },
    left: {
      y: o + (s - o) / 2,
      x: i
    },
    right: {
      y: o + (s - o) / 2,
      x: n
    },
    topLeft: {
      y: r + o,
      x: i
    },
    bottomLeft: {
      y: r + s,
      x: i
    },
    topRight: {
      y: r + o,
      x: n
    },
    bottomRight: {
      y: r + s,
      x: n
    }
  };
}

function e(e, i, n) {
  var o = t(i)[n],
      s = t(e),
      r = window.pageYOffset,
      a = {
    top: r,
    bottom: r + window.innerHeight,
    left: 0,
    right: window.innerWidth
  },
      h = {
    top: {
      x: s.width / 2,
      y: s.height
    },
    bottom: {
      x: s.width / 2,
      y: 0
    },
    left: {
      x: s.width,
      y: s.height / 2
    },
    right: {
      x: 0,
      y: s.height / 2
    },
    topLeft: {
      x: s.width,
      y: s.height
    },
    topRight: {
      x: 0,
      y: s.height
    },
    bottomLeft: {
      x: s.width,
      y: 0
    },
    bottomRight: {
      x: 0,
      y: 0
    }
  },
      p = o.x - h[n].x,
      u = o.y - h[n].y;
  p < a.left ? p = a.left : p + s.width > a.right && (p = a.right - s.width), u < a.top ? u = a.top : u + s.height > a.bottom && (u = a.bottom - s.height), e.style.transform = "translateX(" + Math.round(p) + "px) translateY(" + Math.round(u) + "px)";
}

function i(t) {
  t.length > 0 && t.shift().apply(this, t);
}

function n(t, e) {
  t(), i(e);
}

function o(t, e) {
  return function () {
    var i = [].slice.call(arguments),
        s = i[0];
    if ("number" == typeof s) return o(t, s);
    "number" == typeof e ? setTimeout(function () {
      n(t, i);
    }, e) : n(t, i);
  };
}

function s() {
  var t = [].slice.call(arguments);
  return o(function () {
    i(t.slice(0));
  });
}

var r = function r(t) {
  var e = t.popover;
  void 0 === e && (e = null);
  var i = t.position;
  void 0 === i && (i = "bottom");
  var n = t.transitionSpeed;
  void 0 === n && (n = 0);
  var o = t.onChange;
  void 0 === o && (o = null), this.target = t.target, this.popover = this.createPopover(e), this.position = i, this.transitionSpeed = n, this.onChange = o, this.state = {
    pinned: !1,
    busy: !1,
    requestClose: !1
  }, this.pin = this.pin.bind(this), this.unpin = this.unpin.bind(this), this.block = this.block.bind(this), this.unblock = this.unblock.bind(this), this.isExternalClick = this.isExternalClick.bind(this), this.handleKeyup = this.handleKeyup.bind(this), this.focusNode = null;
};

r.prototype.setState = function (t, e) {
  this.state = Object.assign(this.state, t), e && o(e, 0)();
}, r.prototype.block = function () {
  this.setState({
    busy: !0
  });
}, r.prototype.unblock = function () {
  var t = this;
  this.setState({
    busy: !1
  }, function () {
    t.state.requestClose && t.unpin();
  });
}, r.prototype.toggle = function () {
  this.state.pinned ? this.unpin() : this.pin();
}, r.prototype.pin = function () {
  var t = this;

  if (!this.state.busy && !this.state.pinned) {
    this.setState({
      busy: !0
    }), this.focusNode = document.activeElement;
    var i = o(function () {
      return document.body.appendChild(t.popover);
    }),
        n = o(function () {
      return n = t.target, o = t.position, (i = t.popover).classList.add("is-tacked"), e(i, n, o), {
        update: function update() {
          e(i, n, o);
        },
        destroy: function destroy() {
          i.style.transform = "", i.classList.remove("is-tacked");
        }
      };
      var i, n, o;
    }),
        r = o(function () {
      t.popover.classList.add("is-visible"), t.popover.setAttribute("tabindex", "0"), t.popover.setAttribute("aria-hidden", "false");
    }),
        a = o(function () {
      return t.popover.focus();
    }),
        h = o(function () {
      return t.setState({
        busy: !1,
        pinned: !0
      });
    });
    s(i, n, r(0), a(0), h)(), this.popover.addEventListener("mouseenter", this.block), this.popover.addEventListener("mouseleave", this.unblock), window.addEventListener("click", this.isExternalClick), window.addEventListener("touchstart", this.isExternalClick), window.addEventListener("keyup", this.handleKeyup), window.addEventListener("resize", this.unpin), this.onChange && this.onChange({
      pinned: !0
    });
  }
}, r.prototype.unpin = function (t) {
  var e = this;
  this.setState({
    requestClose: !0
  }), (t || !this.state.busy && this.state.pinned) && o(function () {
    e.setState({
      busy: !0
    }), e.popover.removeEventListener("mouseenter", e.block), e.popover.removeEventListener("mouseleave", e.unblock), window.removeEventListener("click", e.isExternalClick), window.removeEventListener("touchstart", e.isExternalClick), window.removeEventListener("keyup", e.handleKeyup), window.removeEventListener("resize", e.unpin);
    var t = o(function () {
      return e.popover.classList.add("is-hiding");
    }),
        i = o(function () {
      return document.body.removeChild(e.popover);
    }),
        n = o(function () {
      return e.focusNode.focus();
    }),
        r = o(function () {
      e.popover.classList.remove("is-hiding"), e.popover.classList.remove("is-visible"), e.setState({
        busy: !1,
        pinned: !1,
        requestClose: !1
      });
    });
    s(t, i(e.transitionSpeed), n, r)(), e.onChange && e.onChange({
      pinned: !1
    });
  }, 0)();
}, r.prototype.handleKeyup = function (t) {
  27 === t.keyCode && this.unpin();
}, r.prototype.isExternalClick = function (t) {
  t.target === this.popover || this.popover.contains(t.target) || t.target === this.target || this.target.contains(t.target) || this.unpin();
}, r.prototype.createPopover = function (t) {
  var e = document.createElement("div");
  return e.className = "poppy", e.role = "dialog", e.setAttribute("aria-label", "Share Dialog"), e.setAttribute("aria-hidden", "true"), "string" == typeof t ? e.innerHTML = t : e.appendChild(t), e;
};
export default r;